import { Controller } from "@hotwired/stimulus"

// On the tab's form. Refreshes the tab's preview when the office leaves a
// field (lexxy:blur, not per keystroke) by clicking the form's Preview button,
// so the submission carries every unsaved draft into the tab's preview frame.
// Turbo disables the button while a submission is in flight, so a blur that
// lands then is kept and fired once the response is in.
export default class extends Controller {
  static targets = ["button"]

  refresh() {
    if (this.buttonTarget.disabled) {
      this.pending = true
    } else {
      this.buttonTarget.click()
    }
  }

  submitted() {
    if (!this.pending) return

    this.pending = false
    this.buttonTarget.click()
  }
}
